<template>
    <div class="dashboard">
        <form @submit.prevent="search" class="search-form">
            <custom-input v-model="name" :title="$t('MOBILE_DASHBOARD__USERNAME')" @clear="name" />
            <button class="btn">
                {{$t('MOBILE_DASHBOARD__SEARCH')}}
                <i class="material-icons">search</i>
            </button>
        </form>
        <button class="btn add-new" @click="createPopupVisible = true">
            {{$t('MOBILE_DASHBOARD__ADD-NEW')}}
            <i class="material-icons">close</i>
        </button>
        <ul class="user-list">
            <button
                v-for="card in cards"
                :key="card.id"
                class="btn card gray"
                @click="showCustomerInfo(card)"
            >
                <span>{{ computeName(card) }}</span>
                <span>({{ card.balanceDecimal }})</span>
            </button>
        </ul>

        <overlay :visible="createPopupVisible" @clear="createPopupVisible = false">
            <popup :title="$t('MOBILE_DASHBOARD__ADD-NEW')" @close="createPopupVisible = false">
                <form class="create-card" @submit.prevent="createCard">
                    <custom-input
                        v-model="userName"
                        :title="$t('MOBILE_DASHBOARD__USERNAME')"
                        @clear="userName = ''"
                    />
                    <custom-input
                        v-model="password"
                        :title="$t('MOBILE_DASHBOARD__PASSWORD')"
                        @clear="password = ''"
                        helperText="* Min 3 letters"
                    />
                    <div class="actions">
                        <button class="btn create">
                            {{$t('MOBILE_DASHBOARD__CREATE')}}
                            <i class="material-icons">done</i>
                        </button>
                        <div class="btn cancel" @click="createPopupVisible = false">
                            {{ $t('MOBILE_DASHBOARD__CANCEL') }}
                            <i class="material-icons">close</i>
                        </div>
                    </div>
                </form>
            </popup>
        </overlay>

        <overlay :visible="customerPopupVisible" @clear="customerPopupVisible = false">
            <popup
                class="customer-info"
                :title="$t('MOBILE_DASHBOARD__CUSTOMER-INFO')"
                @close="customerPopupVisible = false"
            >
                <ul>
                    <li>
                        <span>{{ $t('MOBILE_DASHBOARD__USERNAME') + ':' }}</span>
                        <span>{{ customerInfo.userName }}</span>
                    </li>
                    <li>
                        <span>{{ $t('MOBILE_DASHBOARD__PASSWORD') + ':' }}</span>
                        <span>{{ customerInfo.password }}</span>
                    </li>
                    <li>
                        <span>{{ $t('MOBILE_DASHBOARD__BALANCE') + ':' }}</span>
                        <span>{{ customerInfo.balanceDecimal }}</span>
                    </li>
                </ul>

                <div class="credit">
                    <button class="btn" @click="changeCredit(false)">
                        <span class="material-icons">remove</span>
                    </button>

                    <custom-input
                        title="+/- Credit"
                        inputType="number"
                        v-model="creditAmount"
                        @clear="creditAmount = ''"
                    ></custom-input>

                    <button class="btn" @click="changeCredit(true)">
                        <span class="material-icons">add</span>
                    </button>
                </div>

                <div class="actions">
                    <button class="btn" @click="lockUnlock()">
                        <span
                            class="material-icons"
                        >{{ !customerInfo.locked ? 'lock' : 'lock_open' }}</span>
                        <span>{{ !customerInfo.locked ? $t('MOBILE_DASHBOARD__LOCK') : $t('MOBILE_DASHBOARD__UNLOCK') }}</span>
                    </button>

                    <button class="btn" @click="generatePassword()">{{$t('MOBILE_DASHBOARD__GENERATE-PASSWORD')}}</button>
                </div>
            </popup>
        </overlay>

        <custom-snackbar
            v-if="snackbar.visible"
            :text="snackbar.text"
            :purpose="snackbar.purpose"
            @close="snackbar.visible = false"
        />
    </div>
</template>

<script>
import Overlay from '@/components/ReusableComponents/Overlay/Overlay.vue'
import Popup from '@/components/ReusableComponents/Popup/Popup.vue'
import axios from '@/Helpers/AxiosInstance.js'
import CustomInput from '@/components/ReusableComponents/CustomInput/CustomInput'
import CustomSnackbar from '@/components/ReusableComponents/CustomSnackbar/CustomSnackbar.vue'
import EventBus from '@/Helpers/EventBus.js'

export default {
    components: {
        CustomInput,
        Popup,
        Overlay,
        CustomSnackbar,
    },
    created() {
        if (this.isSupervisor || !this.isMobile) {
            this.$router.push('/webshops')
        }
    },
    data() {
        return {
            name: '',
            cards: [],
            createPopupVisible: false,
            customerPopupVisible: false,
            customerInfo: {},
            newName: '',
            snackbar: {
                visible: false,
                text: '',
                purpose: '',
            },
            creditAmount: '',
            userName: '',
            password: '',
            isMobile:
                navigator.userAgent.match(/Android/i) ||
                navigator.userAgent.match(/webOS/i) ||
                navigator.userAgent.match(/iPhone/i) ||
                navigator.userAgent.match(/iPad/i) ||
                navigator.userAgent.match(/iPod/i) ||
                navigator.userAgent.match(/BlackBerry/i) ||
                navigator.userAgent.match(/Windows Phone/i),
        }
    },
    methods: {
        search() {
            axios
                .get('WebShop/FilterAccountCards', {
                    params: {
                        FromInternalId: '',
                        ToInternalId: '',
                        WebShopId: '',
                        Assigned: null,
                        Activated: null,
                        Locked: null,
                        FromExternalId: '',
                        ToExternalId: '',
                        FilterString: this.name,
                        OrderColumn: 'id',
                        OrderDirection: 'desc',
                        CurrentPage: 1,
                        PageSize: 10000,
                    },
                })
                .then(resp => {
                    this.cards = resp.data.response
                })
        },
        createCard() {
            axios
                .post('WebShop/CreateCustomerFromWebShop', {
                    userName: this.userName ? this.userName : null,
                    password: this.password ? this.password : null,
                    balance: 0,
                })
                .then(resp => {
                    this.createPopupVisible = false
                    this.snackbar.visible = true

                    if (resp.data.status == 1) {
                        this.customerInfo = resp.data.response
                        this.customerPopupVisible = true

                        this.snackbar.text = 'Success'
                        this.snackbar.purpose = 'success'
                    } else {
                        this.snackbar.purpose = 'error'
                        var code = this.statusCodes.filter(
                            e => e.key == resp.data.status
                        )[0]
                        if (code) this.snackbar.text = this.$t('STATUS-CODE__' + code.value)
                    }
                })
                .catch(() => {
                    this.createPopupVisible = false
                    this.snackbar.visible = true
                    this.snackbar.purpose = 'error'
                    this.snackbar.text = 'An Error Has Occurred!'
                })
        },

        showCustomerInfo(card) {
            this.customerPopupVisible = true
            this.customerInfo = card
        },

        changeCredit(add) {
            var amount = this.creditAmount
            if(!add) amount *= -1

            var data = {
                cardId: this.customerInfo.id,
                amount: amount,
                allowNegativeBalance: false,
            }

            axios
                .post('WebShop/EditUserBalance', data)
                .then(resp => {
                    this.snackbar.visible = true

                    if (resp.data.status == 1) {
                        this.snackbar.text = 'Success'
                        this.snackbar.purpose = 'success'

                        this.creditAmount = ''
                        let updatedAmount = parseInt(this.customerInfo.balance) + parseInt(amount)
                        this.customerInfo.balance = updatedAmount

                        EventBus.$emit('updateBalance')
                    } else {
                        this.snackbar.purpose = 'error'
                        var code = this.statusCodes.filter(
                            e => e.key == resp.data.status
                        )[0]
                        if (code) this.snackbar.text = this.$t('STATUS-CODE__' + code.value)
                    }
                })
                // .catch(() => {
                //     this.snackbar.visible = true
                //     this.snackbar.purpose = 'error'
                //     this.snackbar.text = 'An Error Has Occurred!'
                // })
        },
        lockUnlock() {
            var data = {
                webShopId: this.customerInfo.webShopId,
                externalIdFrom: this.customerInfo.id,
                externalIdTo: this.customerInfo.id,
                locked: !this.customerInfo.locked,
            }

            axios
                .post('WebShop/LockUnlockAccountCards', data)
                .then(resp => {
                    this.snackbar.visible = true

                    if (resp.data.status == 1) {
                        this.snackbar.text = 'Success'
                        this.snackbar.purpose = 'success'

                        this.customerInfo.locked = !this.customerInfo.locked
                    } else {
                        this.snackbar.purpose = 'error'
                        var code = this.statusCodes.filter(
                            e => e.key == resp.data.status
                        )[0]
                        if (code) this.snackbar.text = this.$t('STATUS-CODE__' + code.value)
                    }
                })
                .catch(() => {
                    this.snackbar.visible = true
                    this.snackbar.purpose = 'error'
                    this.snackbar.text = 'An Error Has Occurred!'
                })
        },
        generatePassword() {
            var data = {
                cardId: this.customerInfo.id,
                password: Math.random()
                    .toString(36)
                    .slice(-6),
            }

            axios
                .post('WebShop/EditPassword', data)
                .then(resp => {
                    this.snackbar.visible = true

                    if (resp.data.status == 1) {
                        this.snackbar.text = 'Success'
                        this.snackbar.purpose = 'success'

                        this.customerInfo.password = data.password
                    } else {
                        this.snackbar.purpose = 'error'
                        var code = this.statusCodes.filter(
                            e => e.key == resp.data.status
                        )[0]
                        if (code) this.snackbar.text = this.$t('STATUS-CODE__' + code.value)
                    }
                })
                .catch(() => {
                    this.snackbar.visible = true
                    this.snackbar.purpose = 'error'
                    this.snackbar.text = 'An Error Has Occurred!'
                })
        },
        computeName(card) {
            let calculatedName = card.calculatedName
            let username = card.userName
            let nickName = card.nickName
            if(!calculatedName) {
                if(username && nickName) return `(${username}, ${nickName})`
                if(username) return username
                if(nickName) return nickName
            }
            if(username && username.toLowerCase() != calculatedName.toLowerCase() && nickName && nickName.toLowerCase() != username.toLowerCase()) {
                return `${calculatedName}(${username}, ${nickName})`
            }
            else if(username && username.toLowerCase() != calculatedName.toLowerCase()) {
                return `${calculatedName}(${username})`
            }
            else if(nickName) {
                return `${calculatedName}(${nickName})`
            }
            return calculatedName
        }
    },
    computed: {
        statusCodes() {
            return this.$store.state.statusCodes
        },
        isSupervisor() {
            return this.$store.state.shop
        },
    },
}
</script>

<style scoped lang="scss">
.btn {
    font-size: 18 * $rem;
}

form.search-form {
    display: flex;
    align-items: center;
    justify-content: center;

    label {
        margin-right: 10 * $rem;
    }

    label {
        width: 100%;
    }

    .btn {
        display: flex;
        align-items: center;
        justify-content: center;

        i {
            margin-left: 10 * $rem;
            font-size: 24 * $rem;
        }
    }
}

.add-new {
    margin: 15 * $rem 0;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;

    i {
        transform: rotate(45deg);
        margin-left: 15 * $rem;
        font-size: 24 * $rem;
    }
}

ul.user-list {
    margin-top: 10 * $rem;
    width: 90%;
    margin: auto;

    .btn.card {
        margin-top: 10 * $rem;
        width: 100%;
        background-color: rgb(170, 170, 170);
        display: flex;

        span {
            width: 50%;
            text-align: right;
            padding: 0 10 * $rem;
            box-sizing: border-box;

            &:last-child {
                text-align: left;
            }
        }
    }
}

.create-card {
    .actions {
        margin-top: 30 * $rem;
        display: flex;

        .btn {
            display: flex;
            align-items: center;
            justify-content: center;
            max-width: initial;
            width: 100%;

            i {
                margin-left: 15 * $rem;
            }

            &:last-child {
                margin-left: 10 * $rem;
                background-color: $red;
            }
        }
    }

    label {
        width: 100%;
    }

    label + label {
        margin-top: 15 * $rem;
    }
}

.popup.customer-info {
    ul {
        list-style-type: none;
        padding: 0;

        li {
            font-size: 20 * $rem;
            margin-bottom: 10 * $rem;

            span:last-child {
                margin-left: 10 * $rem;
                font-weight: 500;
            }
        }
    }

    .credit {
        margin: 40 * $rem 0;
        display: flex;

        .btn {
            min-width: 0;
            width: 60 * $rem;
        }

        label {
            width: calc(100% - #{140 * $rem});
            margin: 0 10 * $rem;
        }
    }

    .actions {
        display: flex;

        .btn {
            display: flex;
            align-items: center;
            justify-content: center;
            width: calc(50% - #{5 * $rem});
            height: 50 * $rem;

            & + .btn {
                margin-left: 10 * $rem;
            }

            span.material-icons {
                font-size: 25 * $rem;
            }
            span + span {
                margin-left: 10 * $rem;
            }
        }
    }
}
</style>
